/* eslint-disable camelcase */
import { EnvConfigType, AmplifyConfigType } from './ConfigType';

// tst環境の設定をこちらに追加してください。
// EnvConfigTypeの変更も必要です。

const amplifyConfig: AmplifyConfigType = {
  aws_project_region: 'ap-northeast-1',
  aws_cloud_logic_custom: [
    {
      name: 'PortalAPI',
      endpoint: 'https://sdwx33j0wg.execute-api.ap-northeast-1.amazonaws.com/tst',
      region: 'ap-northeast-1',
    },
    {
      name: 'BaseAPI',
      endpoint: 'https://r8bd0hhek6.execute-api.ap-northeast-1.amazonaws.com/tst',
      region: 'ap-northeast-1',
    },
  ],
};

const config: EnvConfigType = {
  env: 'tst',
  amplifyConfig: amplifyConfig,
  logLevel: 'DEBUG',
  analyticsTrackingId: 'G-LVX2Z44SNM', // Dev用
  inquiryFormUrl: 'about:blank',
  viewerEndpoint: '',
  lpInquiryFormUrl: 'about:blank',
  ymPublishedBibliograpyUrl: 'about:blank',
  siteDomain: isLocal() ? 'localhost' : 'tst.manabi.poplar.co.jp',
  adminUrl: isLocal() ? 'http://localhost:8081' : 'https://admin.tst.manabi.poplar.co.jp',
  yomokkaUrl: isLocal() ? 'http://localhost:8082' : 'https://yomokka.tst.manabi.poplar.co.jp',
  sagasokkaUrl: isLocal() ? 'http://localhost:8083' : 'https://sagasokka.tst.manabi.poplar.co.jp',
  mottosokkaUrl: isLocal() ? 'http://localhost:8080' : 'https://tst.manabi.poplar.co.jp',
  sso: {
    redirectPath: '/loading',
    idpConfig: {
      microsoft: {
        authorizationEndpoint: 'https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize',
        clientId: 'fbd9ca6e-419d-4c08-ad53-09296ef51c27',
        clientSecret: '', // microsoftでは使用しない
        scope: ['openid', 'profile', 'email', 'User.Read'],
      },
      google: {
        authorizationEndpoint: '', // googleでは使用しない
        clientId: '417912956025-64p1i3cu046hao2b45mn1eevjkbfm41r.apps.googleusercontent.com',
        clientSecret: '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',
        scope: ['openid', 'profile', 'email'],
      },
    },
  },
  maintenanceInfoUrl: isLocal()
    ? 'http://localhost:8080/info.txt'
    : 'https://tst.manabi.poplar.co.jp/maintenance/info.txt',
  maintenanceExpiryUrl: isLocal()
    ? 'http://localhost:8080/expiry.txt'
    : 'https://tst.manabi.poplar.co.jp/maintenance/expiry.txt',
};

// ローカル実行でtst環境を起動する場合
function isLocal() {
  const appUrl: string = process.env.VUE_APP_SITE_URL ?? '';
  return appUrl.includes('localhost');
}

export default config;
